// extracted by mini-css-extract-plugin
export default {"root":"_2CHW2mBj","title":"_3B06uJeN","text":"_3nr695qz","center":"_2C-uDjHO","spaced":"_84l_sYyV"};